// src/hooks/products/useGetProducts.js
import { useQuery } from "@tanstack/react-query";
import { getAllProducts } from "../../api/apiProducts";
import i18next from "i18next";

const useGetProducts = (page = 1, perPage = 15, filters = {}) => {
    const { data, error, isLoading, refetch } = useQuery({
        queryKey: ["products", page, perPage, filters, i18next.language],
        queryFn: () => getAllProducts(page, perPage, filters),
    });

    return {
        products: data?.data || {},
        meta: data?.data?.meta || {},
        error,
        isLoading,
        refetch,
    };
};

export default useGetProducts;
